import React from 'react';
import { Element, Input, Box, theme } from '../../index';
import { InputProps } from '../../Atoms/Input/InputProps';

type InputWithIconProps = InputProps & {
  /**
   * Icon, welches angezeigt werden soll.
   */
  icon: any;
  /**
   * Funktion, die bei Klick/Tab auf das Icon aufgerufen wird.
   */
  onIconClick?: () => void;
  /**
   * Accessibility-Titel für den Button des Icons (stark kontextabhängig).
   */
  iconButtonTitle: string;
};

export default function InputWithIcon({
  id,
  dmId = 'dm-input-with-icon',
  style,
  icon: Icon,
  onIconClick = () => {},
  iconButtonTitle,
  ...otherProps
}: InputWithIconProps): JSX.Element {
  const { disabled } = otherProps;
  return (
    <Element
      data-designsystem
      dmId={`${dmId}-container`}
      style={{
        position: 'relative',
      }}>
      <Input
        dmId={dmId}
        id={id}
        style={[
          ({ theme }: any) => ({
            paddingRight: theme.dimension.spacing.xl.rem,
          }),
          style,
        ]}
        {...otherProps}
      />
      <Box
        as="button"
        type="button"
        title={iconButtonTitle}
        dmId={`${dmId}-icon-container`}
        disabled={disabled}
        style={{
          position: 'absolute',
          right: '2px',
          top: '2px',
          width: '42px',
          height: '40px',
          cursor: disabled ? 'not-allowed' : 'pointer',
          alignItems: 'center',
          justifyContent: 'center',
          borderWidth: 0,
          background: 'transparent',
          appearance: 'none',
        }}
        onClick={() => {
          if (!disabled) {
            onIconClick();
          }
        }}>
        <Icon
          id={`${id}-icon` || `${dmId}-icon`} // todo: dmId should be removed, as soon as id prop is required (myt-7757)
          dmId={`${dmId}-icon`}
          color={disabled ? 'currentColor' : theme.palette.color2.hex}
        />
      </Box>
    </Element>
  );
}
